import {TreeDropdown, TreeDropdownConfig} from "@/shared/ui/treeDropdown";
import {Task} from "@/shared/timr";
import {TaskStatusFilter} from "@/shared/timrTypes";

export interface BudgetDashboardTaskDropdownConfig extends TreeDropdownConfig {
	taskStatusFilter: TaskStatusFilter;
}

export class BudgetDashboardTaskDropdown extends TreeDropdown<Task, BudgetDashboardTaskDropdownConfig> {

	private static readonly MIN_QUERY_LENGTH = 3;

	constructor(config: BudgetDashboardTaskDropdownConfig) {
		super({
			...config,
			clearable: true,
			minQueryLength: BudgetDashboardTaskDropdown.MIN_QUERY_LENGTH
		}, {
			loadRootNodesURL: "budgetDashboard/loadAllTasks.json",
			loadSubNodesURL: "budgetDashboard/treeLoad.json",
			filterNodesURL: "budgetDashboard/filterTasks.json",
		});
	}

	get taskStatusFilter(): TaskStatusFilter {
		return this.config.taskStatusFilter;
	}

	public set taskStatusFilter(taskStatusFilter: TaskStatusFilter) {
		if (this.config.taskStatusFilter !== taskStatusFilter) {
			this.config.taskStatusFilter = taskStatusFilter;
			this.reset();
		}
	}

	public setSelectedTask(task?: Task) {
		if (task) {
			this.setSelection(task.id, task.name, task.breadCrumbs, task);
		} else {
			this.setSelection(null, null, null, null);
		}
	}

	protected formatNode(task: Task): string {
		return task.name;
	}

	protected getRequestData(): { taskStatusFilter: TaskStatusFilter } {
		return {
			taskStatusFilter: this.config.taskStatusFilter
		};
	}
}
